/* lua.js generated code 0.3.0 */
require("clover/utils/GameSpeedManager")
require("clover/panel/location/LocationManager")

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var SettingPanel = xClass("SettingPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/setting_panel_setting.csb")
})

SettingPanel.show = function (showGuide) {
    function success() {
        let panel = SettingPanel.create(showGuide)
        panel.popup(true)
    }
    preloadWithLoading(["packed/SettingPausePanelRes.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}

SettingPanel.prototype.init = function (showGuide) {
    var self = this
    BasePanel.prototype.init.call(self)
    
    let device = getDeviceInfo()
    self.device = device
    self.modelLevel = 1  // 微信新出的设备性能接口可以直接给设备分档位。0（档位未知），1（高档机），2（中档机），3（低档机）
    if (window.mini && mini.getSystemInfoSync){
        if (mini.modelLevel && mini.modelLevel > 0){
            self.modelLevel = mini.modelLevel
        }
    }
    console.log("[setting] modelLevel="+self.modelLevel)
    console.log("[setting] deviceQuality="+self.deviceQuality)
    console.log("[setting] deviceBrand="+self.deviceBrand)
    QAGUI.getInstance().print("modelLevel="+self.modelLevel, "setting")
    self.copyTappedTime = 0
    self.copyReplayButton = self.getChild("txt_setting")
    var btn = UIButton.create(self.copyReplayButton)
    btn.on(UIButtonEvent.Click, function () {
        self.onCopyBtnTapped()
    })

    self.musicBtn = self.getChild("music")
    btn = UIButton.create(self.musicBtn)
    btn.on(UIButtonEvent.Click, function () {
        self.onMusicBtnTapped()
    })

    self.soundBtn = self.getChild("sound")
    btn = UIButton.create(self.soundBtn)
    btn.on(UIButtonEvent.Click, function () {
        self.onSoundBtnTapped()
    })
    
    self.helpBtn = self.getChild("com_detail")
    btn = UIGroupButton.create(self.helpBtn)
    ButtonPushBounceAnim.create(btn)
    btn.on(UIButtonEvent.Click, function () {
        self.onHelpBtnTapped()
    })

    self.closeBtn = self.getChild("btn_close")
    btn = UIGroupButton.create(self.closeBtn)
    ButtonPushBounceAnim.create(btn)
    btn.on(UIButtonEvent.Click, function () {
        self.onCloseBtnTapped()
    })
    
    let instance = GameSpeedManager.getInstance()
    if (instance.isEffectLevel(true)) {
        quickBuildUIButton(self.getChild("icon_speedup"), ()=>{
            self.switchSpeed()
    
        })
    } else {
        self.getChild("icon_speedup").visible = false
        self.getChild("txt").visible = false
    }

    // 动画性能
    let animSwitch = UIButton.create(self.getChildByName("onoff"))
    animSwitch.on(UIButtonEvent.Click, function () {
        self.onSmoothBtnTapped()
    })
    self.animSwitch = animSwitch

    self.updateSwitch()
    self.smoothDCSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    DCAssist.dc4SettingSmooth("quality_switch_btn_show", {
        session:self.smoothDCSession,
        sub_id:device.quality, 
        pf:(_G.__level_effect == "LOW"?"smooth":"excellent")
    }) 
    
    if (window.mini && mini.supportContract()) {
        self.privacyAvailable = false
        self.addAlinkText(getText("setting.panel.btn.privacy"), cc.p(240, -177), cc.p(1, 0), () => mini.openPrivacyContract())
        self.addAlinkText(getText("setting.panel.btn.contract"), cc.p(260, -226), cc.p(1, 0), () => mini.openGameContract())
    }else if (PrivacyUtil.isOpen()) {
        var privacy_config = PrivacyUtil.getPrivacy_config()
        if (!privacy_config){
            return
        }
        self.privacyAvailable = true
        //用户协议
        self.addAlinkText(privacy_config["privacy.setting.user_agreement.id"], cc.p(250, -186), cc.p(1, 0), () => PrivacyUtil.openPrivacyPanel("userAgreement",function (){
            self.isBusy = false
        }))
        //隐私政策
        self.addAlinkText(privacy_config["privacy.setting.privacy_policy.id"], cc.p(250, -226), cc.p(1, 0)
            , ()=>{
                PrivacyUtil.openPrivacyPanel("privacyPolicy",function (){ 
                    self.isBusy = false
                })
            }
        )
    }

    self.initLocationUI()
    // let txtString = "根据认{c=255,255,0,255/c}证信息，您已认证为{c=94,113,133,255/c}wei\n未成年人,小于xioa\n的人{c=255,0,0,255/c}"
    // let [colorLabel,labelHeight] = getColorTextH5(txtString,6,24)
    // this.addChild(colorLabel)
    // colorLabel.setPosition(cc.p(410, -290))
    self.initDelAccountUI()

    self.getChildByName("btn_privacy").setVisible(false)
    self.getChildByName("btn_Tencent").setVisible(false)
    self.getChildByName("btn_logout").setVisible(false)

    self.isShowingGuide = false
    if ((showGuide && parseInt(device.quality) > 0 && parseInt(device.quality) <= 24)){
        self.isShowingGuide = true
        let GameGuideMask = require("clover/gameGuide/GameGuideMask")
        let GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
        let frame = self.getChildByName("frame02")
        let pos = frame.getParent().convertToWorldSpace(frame.getPosition())
        let action = table(
            [1, "type", "mask"],
            [1, "fade", 0.01],
            [1, "touchDelay", 1],
            [1, "opacity", null]
        )
        action.hole = table([0, table(
            [1, "type", "square"],
            // [1, "border", 2],
            [1, "posMode", "ui"],
            [1, "panel", self],
            [1, "p1", display.width/2-267],
            [1, "p2", display.height/2-pos.y-68],
            [1, "width", 530],
            [1, "height", 135]
        )])
        action.touch = table([0, table(
            [1, "type", "square"],
            // [1, "border", 2],
            [1, "posMode", "ui"],
            [1, "panel", self],
            [1, "p1", display.width/2-267],
            [1, "p2", display.height/2-pos.y-68],
            [1, "width", 530],
            [1, "height", 135]
        )])
        let mask = GameGuideMask.create(action)
        self.addChild(mask, 1000)
        mask.setPosition(-display.width / 2, -display.height / 2)
        self.mask = mask

        let action2 = table(
            [1, "type", "clickHand"],
            [1, "delay", 0.2],
            [1, "posMode", "ui"],
            [1, "p1", display.width/2+150 ],
            [1, "p2", display.height/2-pos.y ]
        )
        let hand = GameGuideAnims.handClick(action2)
        self.addChild(hand, 1000)
        hand.setPosition(-display.width / 2, -display.height / 2)
        self.hand = hand

        let tipBg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/com_bigpop_bg.png", cc.rect(30, 30, 2, 2))
        tipBg.setContentSize(cc.size(400, 150))
        self.addChild(tipBg, 1000)
        tipBg.setPosition(0, -300)   
        self.smoothTip = tipBg

        let txt = cc.Label.createWithSystemFont(getText("performance.guide"), "Arial", 24)
        tipBg.addChild(txt)
        txt.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
        txt.setPosition(200, 75)
        txt.setTextColor(cc.c4b(177, 115, 68, 255))
        
        DCAssist.dc4SettingSmooth("quality_switch_note_show", {
            session:`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
            pf:(_G.__level_effect == "LOW"?"smooth":"excellent")
        }) 

        // setTimeout(handler(self, self.removeGuide), 3000)
    }

}
SettingPanel.prototype.initDelAccountUI = function() {
    let self = this
    if (AccountManager.getInstance().isOpen()){
        self.addAlinkText("账号删除", cc.p(-140, -224), null, () => {
            AccountManager.getInstance().dcSettingClick()
            AccountManager.getInstance().showDelTipPanel()
            pcall(function () {
                let homeScene = require("clover/scene/HomeScene").getInstance()
                homeScene.btnLayer.buttonBox.close()
                self.onClose()
            })

        })
    }
}
SettingPanel.prototype.initLocationUI = function() {
    let self = this
    let img_location = self.getChildByName("img_location")

    if (!LocationManager.getInstance().isOpen()){
        img_location.setVisible(false)
        return
    }
    img_location.setVisible(true)
    img_location.getChildByName("label").setVisible(false)
    this.img_location = img_location
    
    this.locationLabel = UIItemBuilder.createUnderlineText("上海", 22, cc.color(117, 64, 46, 85))
    // labelNode.getChildByName("label").setScale(2)
    // setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);
    let buttonNode = cc.Node.create()
    buttonNode.addChild(this.locationLabel, undefined, "label")
    buttonNode.setContentSize(this.locationLabel.getContentSize())
    // buttonNode.setPosition(img_location.x + labelNode.getContentSize().width/2 + 10, -290)


    this.locationBtn = UIButton.create(buttonNode, true)
    this.locationBtn.on(UIButtonEvent.Click, ()=> {
        if (self.isBusy){
            return
        }
        self.isBusy = true
        LocationManager.dcClickIcon()
        LocationManager.getInstance().showManualLocationPanel(()=>{
            this.isBusy = false
        },{
            cb: ()=> {
                self.refreshLocationUI()
            }
        })
    })
    self.addChild(this.locationBtn)
    self.refreshLocationUI()
}
SettingPanel.prototype.refreshLocationUI = function() {
    let location = UserManager.getInstance().location
    let localName = LocationManager.getInstance().getProvinceName()
    this.locationLabel.setString(localName)
    this.locationBtn.setPosition(this.img_location.x + this.locationLabel.getContentSize().width/2 + 20, -177)

}
//可显示四种速度
SettingPanel.prototype.switchSpeed = function(event){
    var self = this
    //  优先检查当前模式是否可修改速度
    if (self.bubble && self.bubble.visible){
        self.bubble.setVisible(false)
    }

    console.log("GamePlayConfig_GameBoard_Speed_Select_Default", GamePlayConfig_GameBoard_Speed_Select_Default)
    let instance = GameSpeedManager.getInstance()
    if (!instance.isEffectLevel(true)) return

    // 0 1 2 3
    let currentIndex = instance.getSpeed(GameLevelType["kMainLevel"])
    if (GamePlayConfig_GameBoard_Speed[currentIndex + 1]){
        instance.setAllSpeed(currentIndex + 1)
    }else {
        instance.setAllSpeed(0)
    }
    self.updateSwitch()

    Toast.make(getText("speedup.success.tip"))

}
SettingPanel.prototype.addAlinkText = function(txt, pos, anchor, onclick) {
    let self = this
    let labelNode = UIItemBuilder.createUnderlineText(txt, 22, cc.color(117, 64, 46, 85))

    let buttonNode = cc.Node.create()
    buttonNode.addChild(labelNode, undefined, "label")
    buttonNode.setContentSize(labelNode.getContentSize())
    buttonNode.setPosition(pos)
    if (anchor){
        buttonNode.setAnchorPoint(anchor)
    }

    let btn = UIButton.create(buttonNode, true)
    btn.on(UIButtonEvent.Click, function() {
        if (self.isBusy && self.privacyAvailable){
            return
        }
        onclick()
    })
    self.addChild(btn)
}

function showDebugInfo() {
    let debug_info = document.createElement('div');
    debug_info.setAttribute('style', '-webkit-user-select:all; user-select:all; position: absolute;top: 0;width: 100%;height: 100%;left: 0;background-color: cornsilk;opacity: 0.8;');
    document.getElementsByTagName("body")[0].appendChild(debug_info)
    debug_info.addEventListener("click", function () {
        debug_info.remove()
    })
    function callback(data) {
        debug_info.innerHTML = JSON.stringify(data, null, 4)
    }
    GameProxy.getInstance().getDebugInfo(callback)
}

SettingPanel.prototype.onCopyBtnTapped = function () {
    var self = this
    self.copyTappedTime = self.copyTappedTime + 1
    if (self.copyTappedTime >= 5) {
        self.copyTappedTime = 0
        showDebugInfo()
    }
}

SettingPanel.prototype.updateSwitch = function () {
    var self = this
    var isMusicOpen = MusicPlayer.getInstance().IsBackgroundMusicOpen
    self.musicBtn.getChildByName("on").setVisible(isMusicOpen)
    self.musicBtn.getChildByName("off").setVisible(!isMusicOpen)
    var isSoundOpen = MusicPlayer.getInstance().IsMusicOpen
    self.soundBtn.getChildByName("on").setVisible(isSoundOpen)
    self.soundBtn.getChildByName("off").setVisible(!isSoundOpen)
    
    let showValue = GameSpeedManager.getInstance().getSpeed(GameLevelType["kMainLevel"]) + 1

    self.getChild("icon_speedup").getChildByName("text").setString("x" + showValue)

    let switchOn = (_G.__level_effect == "LOW") // 是否开了低
    let [on, off] = [self.animSwitch.getChildByName("on"), self.animSwitch.getChildByName("off")]
    let [onTag, offTag] = [self.getChildByName("on_tag"), self.getChildByName("off_tag")]
    on.setVisible(switchOn)
    off.setVisible(!switchOn)
    if(self.modelLevel > 0){
        let onTagShow = false
        if (self.modelLevel > 1){
            onTagShow = true
        }
        onTag.setVisible(onTagShow)
        offTag.setVisible(!onTagShow)
    }
    let http = ClientConfigHttp.new(false)
    http.load()
}

SettingPanel.prototype.onSmoothBtnTapped = function () {
    var self = this
    if (self.isBusy) {
        return
    }
    
    if (self.isShowingGuide){
        self.removeGuide()
    }
    
    let now = Localhost.timeInSec()
    let userDefault = cc.UserDefault.getInstance()
    let firstClickTime = userDefault.getIntegerForKey("game.switch.effect.recommand.tip")
    QAGUI.getInstance().print("now="+now, "setting")
    QAGUI.getInstance().print("firstClickTime="+firstClickTime, "setting")
    if (firstClickTime == 0){
        userDefault.setIntegerForKey("game.switch.effect.recommand.tip", now)
        require("clover/panel/SettingPanelRecommandTip").show(self.modelLevel)
        return
    }

    self.isBusy = true

    let pre = _G.__level_effect
    let okCb = function(){
        let result = toggleUseLowEffect()
        self.updateSwitch()
        self.isBusy = false

        DCAssist.dc4SettingSmooth("quality_switch_btn_click", {
            session:self.smoothDCSession,
            pf:(pre == "LOW"?"smooth":"excellent"),
            plt:(_G.__level_effect == "LOW"?"smooth":"excellent")
        }) 
    }
    
    let lastTime
    if (_G.__level_effect == "LOW"){
        lastTime = userDefault.getIntegerForKey("game.enable.high.effect.tip")
    }else{
        lastTime = userDefault.getIntegerForKey("game.enable.low.effect.tip")
    }
    QAGUI.getInstance().print("no="+now,"setting")
    QAGUI.getInstance().print("lastTime="+lastTime,"setting")
    if (now == 0 || !isSameYMD(now, lastTime)){
        if ((_G.__level_effect == "LOW" && self.modelLevel > 1)
            || (_G.__level_effect != "LOW" && self.modelLevel == 1)){
            require("clover/panel/SettingPanelTip").show(okCb)
        }else{
            okCb()
        }
        if (_G.__level_effect == "LOW"){
            userDefault.setIntegerForKey("game.enable.high.effect.tip", now)
        }else{
            userDefault.setIntegerForKey("game.enable.low.effect.tip", now)
        }
    }else{
        okCb()
    }
}

SettingPanel.prototype.removeGuide = function(){
    var self = this
    self.isShowingGuide = false
    if (self.mask){
        self.mask.removeFromParent()
        self.mask = null
    }
    if (self.hand){
        self.hand.removeFromParent()
        self.hand = null
    }
    if (self.smoothTip){
        self.smoothTip.removeFromParent()
        self.smoothTip = null
    }
}

SettingPanel.prototype.onMusicBtnTapped = function () {
    var self = this
    if (MusicPlayer.getInstance().IsBackgroundMusicOpen) {
        MusicPlayer.getInstance().pauseBackgroundMusic()
    } else {
        MusicPlayer.getInstance().resumeBackgroundMusic()
    }
    self.musicBtn.stopAllActions()
    self.musicBtn.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 0.87), cc.CallFunc.create(function () {
        self.updateSwitch()
    }), cc.ScaleTo.create(0.08, 1.05), cc.ScaleTo.create(0.02, 1)))
    if (self.onMusicBtnClickCallback) {
        self.onMusicBtnClickCallback()
    }
}

SettingPanel.prototype.onSoundBtnTapped = function () {
    var self = this
    if (MusicPlayer.getInstance().IsMusicOpen) {
        MusicPlayer.getInstance().pauseSoundEffects()
    } else {
        MusicPlayer.getInstance().resumeSoundEffects()
    }
    self.soundBtn.stopAllActions()
    self.soundBtn.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 0.87), cc.CallFunc.create(function () {
        self.updateSwitch()
    }), cc.ScaleTo.create(0.08, 1.05), cc.ScaleTo.create(0.02, 1)))
}
SettingPanel.prototype.onSpeed2BtnTapped = function(event){
    var self = this
    //  优先检查当前模式是否可修改速度
    let instance = GameSpeedManager.getInstance()
    if (instance.isEffectLevel(true)) {
        //  可修改，执行修改
        self.isSpeed2 = !self.isSpeed2
        if (self.isSpeed2){
            instance.setAllSpeed(1)
        }else{
            instance.setAllSpeed(0)
        }
        Toast.make(getText("speedup.success.tip"))
    } else {
        //  当前模式不可修改
    }
}

SettingPanel.prototype.onHelpBtnTapped = function (event) {
    var self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    ActivityCommon.showExplain(() => {
        self.isBusy = false
    }, {
        cHeight : 600,
        text: getText("performance.text"),
        title: "动画性能说明"
    })
}

SettingPanel.prototype.onCloseBtnTapped = function (event) {
    var self = this
    self.onClose()
}

SettingPanel.prototype.popup = function () {
    var self = this
    // body
    var targetScale = self.getScale()
    self.setScale(0)
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    var vSize = cc.Director.getInstance().getVisibleSize()
    var targetPos = cc.p((vSize.width - s.width) * 0.5 + s.width * pos.x, (vSize.height + s.height) * 0.5 + s.height * pos.y)
    self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
    var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.05)
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint))), cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))))
    return self
}

SettingPanel.prototype.onClose = function () {
    var self = this
    let homeScene = require("clover/scene/HomeScene").getInstance()
    if (homeScene.btnLayer) {
        homeScene.btnLayer.updateBoxPrompt()
    }
    BasePanel.prototype.onClose.call(self)
}

SettingPanel.prototype.fitResolution = function () {
    var self = this
    // body
}
SettingPanel.prototype.onCleanup = function () {
    ResManager.release(["packed/SettingPausePanelRes.pack"])
}

SettingPanel.prototype.onCopyBtnTapped = function(){
    let self = this
    if (self.clickCopyBtn == null){
        self.clickCopyBtn = 1
        setTimeout(()=>{
            self.clickCopyBtn = null
        }, 2000)
    }else{
        self.clickCopyBtn = self.clickCopyBtn + 1
    }
    if (self.clickCopyBtn >= 5){
        let success = (evt) => {
            console.log("[QueryUserInOpenConsoleListHttp]", evt)
            if (evt.data.status == true){
                QAGUI.getInstance().show()
            }
        }
    
        let fail = (evt) => {}
    
        let http = QueryUserInOpenConsoleListHttp.new();
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, fail);
        http.addEventListener(Events.kCancel, fail);
        http.load();
    }
}

module.exports = SettingPanel
